import React, { useMemo, useState, useEffect } from 'react';
import Vendorproductt from './Vendorproduct';
import { Card, Modal, Form, Button, Row, Col, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { MdDelete } from 'react-icons/md';
import { FiPlusCircle } from 'react-icons/fi';
import { HiOutlineMinusCircle } from 'react-icons/hi';
import { FaEye } from "react-icons/fa";
import { FaSearch, FaPlus, FaEdit } from "react-icons/fa";
import Select from 'react-select';
import { FaArrowAltCircleRight } from "react-icons/fa";
// import { MdDelete } from "react-icons/md";

import { toast, ToastContainer } from 'react-toastify';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';

import axios from 'axios';
import OrderProductRawMaterialView from './OrderProductRawMaterialView';
import CustumerProductview from './CustumerProductview';
import VendorReceiveView from './VendorReceiveView';
import AddReceive from './AddReceive';

const VendorManufactureProductdetails = () => {
    const token = localStorage.getItem('token');
    const [orderlist, setOrderList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [rowMatrialslist, setRowMatrialslist] = useState([]);
    const [Rows, setRows] = useState([]);
    const [counters, setCounters] = useState([]);
    const [VendorTrading, setVendorTrading] = useState([]);
    const [VendorId, setVendorID] = useState([]);
    const [totalUnitPrice, settotalUnitPrice] = useState(0);
    const [totalWorkDone, settotalWork] = useState(0);
    const [totalUnitPrice1, settotalUnitPrice1] = useState(0);
    const [componentManufactureID, setcomponentManufactureID] = useState("");
    const [newPrice, setnewPrice] = useState(0);
    const [newWorkDone, setWorkDone] = useState(0);
    const [manufacturee, setManufacture] = useState([]);
    const order_Update_id = localStorage.getItem('order_Update_id');
    const [categories, setCategories] = useState([]);
    const [components, setComponents] = useState([]);
    const [venderlist, setVenderlist] = useState([]);
    const [extra_categories, setCategoriesExtra] = useState([]);
    const [data, setViewData] = useState([]);
    const [formData, setFormData] = useState([]);
    const [fields, setFields] = useState({
        date: '',
        vender_id: '',
        product_id: '',
        qty: '',
    });

    const [rows1, setRows1] = useState([
        {
            category_id: null,
            product_id: null,
            area_id: null,
            component_order: [
                {
                    area_description: '',
                    cost_price: 0,
                    sale_price: 0,
                    sub_component_order: [
                        { component_id: null, vender_id: null }
                    ]
                }
            ]
        }
    ]);

    const [modalData, setModalData] = useState({
        order_id: '',
        vender_id: '',
        item_id: '',
        product_id: '',
        qty: 1,
        unit_price: '',
        work_done: '',
        area_description_id: '',
        category_id: '',
        product_order_id: '',
        component_id: ''
    });
    const [modalState, setModalState] = useState({
        addVendor: false,
        addReceive: false,
        orderProductView: false,
        orderVendorView: false,
    });
    // console.warn("fgfd", componentManufactureID)
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // console.warn(initialProductDetails);
    const [productDetails, setProductDetails] = useState({});
    const [ProductDetailsvdrid, setProductDetailsvdrid] = useState([]);

    const handleInputChange1 = (
        order_id,
        category_id,
        total_cost_price,
        total_sale_price,
        category_name,
        remaining_cost,
    ) => {
        handleShow();
        const payload = {
            order_id,
            category_id,
            total_cost_price,
            total_sale_price,
            category_name,
            remaining_cost,
        };
        console.warn("kumkumsss", payload);
        setModalData({
            order_id: payload.order_id,
            category_id: payload.category_id,
            total_cost_price: payload.total_cost_price,
            total_sale_price: payload.total_sale_price,
            category_name: payload.category_name,
            remaining_cost: payload.remaining_cost,

        });
        fetchProducts(order_id);
    };

    const handleComponentSelection = (rowIndex, fieldIndex, extraFieldIndex, selected) => {
        const updatedRows = [...rows1];
        updatedRows[rowIndex].fields[fieldIndex].extraFields[extraFieldIndex].component = selected ? selected.value : null;
        setRows1(updatedRows);
    };


    const handleVendorSelection = (rowIndex, fieldIndex, subIndex, selected) => {
        const updatedRows = [...rows1];
        const updatedComponentOrder = [...updatedRows[rowIndex].component_order];
        const updatedSubComponentOrder = [...updatedComponentOrder[fieldIndex].sub_component_order];

        updatedSubComponentOrder[subIndex] = {
            ...updatedSubComponentOrder[subIndex],
            vender_id: selected ? selected.value : null,
        };

        updatedComponentOrder[fieldIndex] = {
            ...updatedComponentOrder[fieldIndex],
            sub_component_order: updatedSubComponentOrder,
        };

        updatedRows[rowIndex] = {
            ...updatedRows[rowIndex],
            component_order: updatedComponentOrder,
        };

        setRows(updatedRows); // Update state
    };


    const handleUnitprice = (rowIndex, fieldIndex, subIndex, newPrice, categoryId) => {
        const updatedRows = [...rows1];
        const updatedComponentOrder = [...updatedRows[rowIndex].component_order];
        const updatedSubComponentOrder = [...updatedComponentOrder[fieldIndex].sub_component_order];

        updatedSubComponentOrder[subIndex] = {
            ...updatedSubComponentOrder[subIndex],
            unit_price: newPrice,  // Update unit price
        };

        updatedComponentOrder[fieldIndex] = {
            ...updatedComponentOrder[fieldIndex],
            sub_component_order: updatedSubComponentOrder,
        };

        updatedRows[rowIndex] = {
            ...updatedRows[rowIndex],
            component_order: updatedComponentOrder,
        };

        setRows1(updatedRows); // Update state
        setnewPrice(newPrice);

        // Calculate the total unit price based on category_id and store it in state
        const total = updatedRows.reduce((total, row) => {
            row.component_order.forEach((component) => {
                component.sub_component_order.forEach((subComponent) => {
                    if (subComponent.category_id === categoryId) {
                        const unitPrice = parseFloat(subComponent.unit_price) || 0;  // Ensure it's treated as a number
                        total += unitPrice;
                    }
                });
            });
            return total;
        }, 0);

        settotalUnitPrice(total); // Update the state with the new total

        // Store the updated total in localStorage
        localStorage.setItem(`category_total_${categoryId}`, total);

        console.log(`Total unit price for category ${categoryId}:`, total);
    };
    // const handleWorkDoneprice = (rowIndex, fieldIndex, subIndex, workDonePrice, categoryId) => {
    //     const updatedRows = [...rows1];
    //     const updatedComponentOrder = [...updatedRows[rowIndex].component_order];
    //     const updatedSubComponentOrder = [...updatedComponentOrder[fieldIndex].sub_component_order];

    //     updatedSubComponentOrder[subIndex] = {
    //         ...updatedSubComponentOrder[subIndex],
    //         work_done: workDonePrice, 
    //     };

    //     updatedComponentOrder[fieldIndex] = {
    //         ...updatedComponentOrder[fieldIndex],
    //         sub_component_order: updatedSubComponentOrder,
    //     };

    //     updatedRows[rowIndex] = {
    //         ...updatedRows[rowIndex],
    //         component_order: updatedComponentOrder,
    //     };

    //     setRows1(updatedRows); // Update state
    //     setWorkDone(workDonePrice);

    //     const total = updatedRows.reduce((total, row) => {
    //         row.component_order.forEach((component) => {
    //             component.sub_component_order.forEach((subComponent) => {
    //                 if (subComponent.category_id === categoryId) {
    //                     const workDone = parseFloat(subComponent.work_done) || 0;  
    //                     total += workDone;
    //                 }
    //             });
    //         });
    //         return total;
    //     }, 0);

    //     settotalWork(total); 
    //     localStorage.setItem(`category_total_${categoryId}`, total);

    //     console.log(`Total unit price for category ${categoryId}:`, total);
    // };


    const handleWorkDoneprice = (rowIndex, fieldIndex, subIndex, workDonePrice, categoryId) => {
        const updatedRows = [...rows1];
        const updatedComponentOrder = [...updatedRows[rowIndex].component_order];
        const updatedSubComponentOrder = [...updatedComponentOrder[fieldIndex].sub_component_order];
    
        updatedSubComponentOrder[subIndex] = {
            ...updatedSubComponentOrder[subIndex],
            work_done: workDonePrice,
        };
    
        updatedComponentOrder[fieldIndex] = {
            ...updatedComponentOrder[fieldIndex],
            sub_component_order: updatedSubComponentOrder,
        };
    
        updatedRows[rowIndex] = {
            ...updatedRows[rowIndex],
            component_order: updatedComponentOrder,
        };
    
        setRows1(updatedRows);
    
        // Calculate total work done for the category
        const total = updatedRows.reduce((total, row) => {
            row.component_order.forEach((component) => {
                component.sub_component_order.forEach((subComponent) => {
                    if (subComponent.category_id === categoryId) {
                        const workDone = parseFloat(subComponent.work_done) || 0;
                        total += workDone;
                    }
                });
            });
            return total;
        }, 0);
    
        settotalWork(total);
        localStorage.setItem(`category_total_${categoryId}`, total);
        console.log(`Total work done for category ${categoryId}:`, total);
    };
    
    const handleDate = (rowIndex, fieldIndex, subIndex, newDate) => {
        // Make sure to clone the rows and substructures deeply to avoid direct mutation of state
        const updatedRows = rows1.map((row, rIndex) => {
            if (rIndex === rowIndex) {
                const updatedComponentOrder = row.component_order.map((component, cIndex) => {
                    if (cIndex === fieldIndex) {
                        const updatedSubComponentOrder = component.sub_component_order.map((subComponent, sIndex) => {
                            if (sIndex === subIndex) {
                                return {
                                    ...subComponent, // Spread the subcomponent object
                                    date: newDate,  // Update the date here
                                };
                            }
                            return subComponent;
                        });
                        return {
                            ...component, // Spread the component object
                            sub_component_order: updatedSubComponentOrder,  // Update the sub_component_order
                        };
                    }
                    return component;
                });
                return {
                    ...row,  // Spread the row object
                    component_order: updatedComponentOrder,  // Update the component_order
                };
            }
            return row;
        });

        setRows1(updatedRows);  // Update the state with the new rows
        console.warn("updatedRows", updatedRows);  // Log the updated rows for debugging
    };


    const handleDeleteExtraField = (rowIndex, fieldIndex, extraFieldIndex) => {
        const updatedRows = [...rows1];
        updatedRows[rowIndex].fields[fieldIndex].extraFields.splice(extraFieldIndex, 1);
        setRows1(updatedRows);
    };

    console.warn("rows1", rows1)
    const handleRowChange = (index, field, value) => {
        const updatedRows = [...rows1];
        updatedRows[index][field] = value;
        console.warn("dd", field);
        if (field === "category_id") {
            // Filter components based on selected category_id
            const filtered = componentOptions.filter(component => component.category_Id === value);
            // setFilteredComponents(filtered);

            console.log("filtered", filtered);
        }
        if (field === "area") {
            const areaValue = value;
            updatedRows[index].fields = [];
            for (let i = 0; i < areaValue; i++) {
                updatedRows[index].fields.push({
                    // id: uuidv4(),
                    area_description: '',
                    cost_price: '',
                    sale_price: '',
                    extraFields: []
                });
            }
        }

        setRows1(updatedRows);
        console.log("rowssssssss", updatedRows);
    };


    const handleSubmit = async (payload) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}Add-Receive-Product-Row-Matrials-store`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });
            if (response.data.status === 1) {
                // toast.success(response.data.message);
                fetchOrderlist();
            } else {
                // toast.error(response.data.message);
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error('An error occurred');
        }
    };
    const handleUpdateDate = async (payload) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}Add-Receive-Product-update-date-manufacture-Row-Matrials-store-price/${payload.add_receive_id}`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });
            if (response.data.status === 1) {
                // toast.success(response.data.message);
                fetchOrderlist();
            } else {
                // toast.error(response.data.message);
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error('An error occurred');
        }
    };

    const handleSubmit1 = async (id, component_id, vender_id, area_description_id, unit_price, date, product_id, order_id) => {
        // Check for required fields
        if (manufacturee === 'Manufacture') {
            if (!modalData.vender_id) {
                alert('Vendor Name is required');
                return;
            }
            if (!modalData.component_id) {
                alert('Component Name is required');
                return;
            }
        }


        const unitPrice = modalData.unit_price || 0;

        const subComponentData = rows1
            .map((row1) =>
                row1.component_order.map((field) =>
                    field.sub_component_order
                        ? field.sub_component_order
                            .filter(extraField => extraField.product_id === modalData.product_id)
                            .map((extraField) => ({
                                // You can add any necessary fields here
                            }))
                        : []
                )
            )
            .flat(2);  // Flatten the array to a single level

        // Prepare the payload with the required fields
        const newPayload = {
            order_id: modalData.order_id,
            category_id: modalData.category_id,
            item_id: null,
            product_id,
            product_order_id: modalData.product_order_id,
            qty: Number(modalData.qty),
            unit_price: Number(unitPrice),
            manufacture: "Manufacture",
            sub_component_order_id: id,
            component_id,
            vender_id,
            area_description_id,
            unit_price,
            date,
        };

        console.warn("Payload to be sent:", newPayload);

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}Add-Receive-Product-Manufacture-Row-Matrials-store-price`, newPayload, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });

            if (response.data.status === 1) {
                fetchOrderlist(); // Refresh the order list
                toast.success(response.data.message);
                fetchProducts(order_id)
            } else {
                console.error('Error from backend:', response.data.message);
            }

        } catch (error) {
            console.error('Error during submission:', error);
            toast.error('An error occurred');
        }
    };
    const handleUpdate1 = async (id, component_id, vender_id, area_description_id, unit_price, work_done, add_receive_id, date, product_id, order_id) => {
        // Check for required fields
        if (manufacturee === 'Manufacture') {
            if (!modalData.vender_id) {
                alert('Vendor Name is required');
                return;
            }
            if (!modalData.component_id) {
                alert('Component Name is required');
                return;
            }
        }
        const unitPrice = modalData.unit_price || 0;

        const subComponentData = rows1
            .map((row1) =>
                row1.component_order.map((field) =>
                    field.sub_component_order
                        ? field.sub_component_order
                            .filter(extraField => extraField.product_id === modalData.product_id)
                            .map((extraField) => ({
                                // You can add any necessary fields here
                            }))
                        : []
                )
            )
            .flat(2);  // Flatten the array to a single level

        // Prepare the payload with the required fields
        const newPayload = {
            order_id: modalData.order_id,
            category_id: modalData.category_id,
            item_id: add_receive_id,
            product_id,
            product_order_id: modalData.product_order_id,
            qty: Number(modalData.qty),
            unit_price: Number(unitPrice),
            work_done,
            manufacture: "Manufacture",
            sub_component_order_id: id,
            component_id,
            vender_id,
            area_description_id,
            unit_price,
            date,
        };
        console.warn("Payload to be sent:", newPayload);
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}Add-Receive-Product-update-Manufacture-Row-Matrials-store-price/${add_receive_id}`, newPayload, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });

            if (response.data.status === 1) {
                fetchOrderlist(); // Refresh the order list
                toast.success(response.data.message);
                fetchProducts(order_id)
            } else {
                console.error('Error from backend:', response.data.message);
            }


        } catch (error) {
            console.error('Error during submission:', error);
            toast.error('An error occurred');
        }
    };

    const navigate = useNavigate();

    useEffect(() => {
        if (!modalState.addReceive) {
            fetchOrderlist();


        }
    }, [modalState.addReceive, token]);
    const fetchOrderlist = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}Crete-custumer-product-name-manufacture-list`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });
            const orders = response.data.data || [];
            console.warn("dfgdf", orders);

            // Filter orders where manufacture is 'Manufacture'
            // want to show order ina acending order

            const filteredOrders = orders
                .filter(order => order.manufacture === 'Manufacture')
                .sort((a, b) => b.id - a.id);
            // const filteredOrders = orders.filter(order => order.manufacture === 'Manufacture');

            setOrderList(filteredOrders);
            // Maintain unique area_description_id using Set
            const uniqueAreaIds = new Set();
            const refinedOrders = filteredOrders.map(order => ({
                ...order,
                product_data: order.product_data.filter(product => {
                    if (!uniqueAreaIds.has(product.category_id)) {
                        uniqueAreaIds.add(product.category_id);
                        return true;
                    }
                    return false;
                })
            })).filter(order => order.product_data.length > 0); // Keep only orders with valid products

            // setOrderList(refinedOrders);
            console.warn("filteredOrderssssss", refinedOrders);


            const initialDetails = {};
            refinedOrders.forEach(order => {
                const { customer_name, manufacture } = order;

                setProductDetails(prevFields => ({
                    ...prevFields,
                    CustumerName: customer_name,
                    manufacture,
                }));

                order.product_data.forEach(product => {
                    initialDetails[product.vdr_id] = {
                        product_id: product.product_id,
                        order_id: product.order_id,
                        vender_id: product.vender_id,
                        component_id: product.component_id,
                        qty: product.qty,
                        unit_price: product.unit_price,
                        date: product.date,
                        vdr_id: product.vdr_id,
                        manufacture: product.manufacture,
                        area_description_id: product.area_description_id,
                        customerName: customer_name,
                    };
                });
            });

            setProductDetails(initialDetails);
            const filteredOrdersvdrid = orders.filter(order => order.manufacture === 'Manufacture');
            // console.warn("Filtered Orders: ", filteredOrders);



            const initialDetailsvdrid = {};
            filteredOrdersvdrid.forEach(order => {
                const customerName = order.customer_name;
                const manufacture = order.manufacture;

                setProductDetailsvdrid(prevFields => ({
                    ...prevFields,
                    CustumerName: customerName,
                    manufacture: manufacture,
                }));

                order.product_data.forEach(product => {
                    initialDetailsvdrid[product.vdr_id] = {

                        date: product.date,
                        vdr_id: product.vdr_id,
                        sub_component_order_id: product.sub_component_order_id,

                        area_description_id: product.area_description_id,

                    };
                });

            });
            setProductDetailsvdrid(initialDetailsvdrid);
            console.warn("initialDetailsvdrid", initialDetailsvdrid)
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };



    const componentOptions = components.map((item) => ({
        value: item.id,
        label: item.name,
        category_Id: item.category_Id,
    }));
    const vendorOptions = venderlist.map((item) => ({ value: item.id, label: item.vendor_name, }));

    useEffect(() => {
        const fetchComponents = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}component-list`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                });
                setComponents(response.data.data || []);
            } catch (error) {
                console.error('Error fetching components:', error);
            }
        };
        if (!modalState.addproduct, rows1) {
            fetchComponents();
            // setRows();        
        }
    }, [token, modalState.addproduct]);



    useEffect(() => {
        const fetchVendor = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}Vender-list`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                });
                setVenderlist(response.data.data || []);
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        };

        fetchVendor();
        // setRows();        

    }, [token]);

    const handleFieldChange = (rowIndex, fieldIndex, fieldName, value) => {
        const updatedRows = [...rows1];
        updatedRows[rowIndex].component_order[fieldIndex][fieldName] = value;
        setRows1(updatedRows); // Update the state
    };


    const fetchProducts = async (order_id) => {
        try {
            const url = `${process.env.REACT_APP_API_URL}Order-view-product-list/${order_id}`;
            const config = {
                method: 'get',
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            };
            const response = await axios(config);
            const { createOrder, product, component_order, sub_component_order, extra_charges_store, product_other_data } = response.data.rows;
            console.warn("sub_component_order", sub_component_order)


            const orderDetails = createOrder[0];
            setViewData({
                ...orderDetails,
                products: product,
                componentOrder: component_order,
                subcomponentOrder: sub_component_order,
                extra_products: extra_charges_store,
                otherData: product_other_data || []
            });
            const customerData = orderDetails;
            setFormData({
                customer_id: customerData.id,
                account_id: customerData.account_id,
                account_mode: customerData.account_mode,
                due_amt: customerData.due_amt,
                order_date: customerData.order_date,
                customer_name: customerData.customer_name,
                customer_type: customerData.customer_type,
                invoice_number_manual: customerData.invoice_number_manual,
                description: customerData.description,
                mobile_number: customerData.mobile_number,
                site_name: customerData.site_name,
                pincode: customerData.pincode,
                email: customerData.email,
                city: customerData.city,
                state: customerData.state,
                address1: customerData.address1,
                address2: customerData.address2,
                account_name: customerData.account_id,
                payer_name: customerData.payer_name,
                receiver_name: customerData.receiver_name,
                amount: customerData.amount,
                total_price: customerData.total_price,
                delivery_date: customerData.delivery_date,
                manufacture: orderDetails.manufacture,
                c_gst: orderDetails.c_gst,
                s_gst: orderDetails.s_gst,
                total_amount: orderDetails.total_amount,
                gst_in_no: orderDetails.gst_in_no,
                vehicle_number: orderDetails.vehicle_number,
                // order_id_id: orderDetails.product[0].order_id,
            });
            // setTotalcustomerDataamount(customerData.amount)
            if (product.length > 0) {
                // Map product data
                let updatedRowsss = product.map(item => ({
                    product_order_id: item.product_order_id,
                }));
                const uniqueProductIds = new Set();

                // Map product data and ensure unique product IDs
                let updatedRows = product
                    .filter(item => {
                        // Check if product_id is already in the Set
                        if (uniqueProductIds.has(item.product_id)) {
                            return false; // Skip duplicates
                        }
                        uniqueProductIds.add(item.product_id);
                        return true; // Include unique items
                    })
                    .map(item => ({
                        id: item.product_order_id,
                        order_id: item.order_id,
                        vendor_id: item.vender_id,
                        category_id: item.category_id,
                        product_id: { id: item.product_id, name: item.name },
                        qty: item.qty,
                        qty_old: item.qty,
                        pro_qty: item.pro_qty,
                        price: item.price,
                        gst: item.gst,
                        manufacture: item.manufacture,
                        pro_unit: item.pro_unit,
                        hsn_no: item.hsn_no,
                        total_amount: item.total_amount,
                        sale_price: item.sale_price,
                        area_id: item.area_id,
                        area_description_id: item.area_description_id,
                        component_order: [],

                    }));


                // setproductorderID(updatedRowsss);
                // Include component_order data with same category_id

                if (component_order.length > 0) {
                    updatedRows = updatedRows.map(row => ({
                        ...row,
                        component_order: component_order
                            .filter(component => component.product_id === row.product_id.id) // Match category_id
                            .map(component => ({
                                id: component.id,
                                area_description: component.area_description,
                                area_id: Number(component.area_id),
                                cost_price: component.cost_price,
                                sale_price: component.sale_price,
                                category_id: component.category_id,
                                product_id: component.product_id,
                                area_description_id: component.area_description_id,
                                sub_component_order: [],

                            }))
                    }));
                }

                if (sub_component_order && sub_component_order.length > 0) {

                    updatedRows = updatedRows.map(row => ({
                        ...row,
                        component_order: row.component_order.map(component => ({
                            ...component,
                            sub_component_order: sub_component_order.filter(subComponent =>
                                component.area_description_id == subComponent.area_description_id
                            ).map(subComponent => ({
                                id: subComponent.id,
                                area_des_id: component.id,
                                component_id: subComponent.component_id,
                                area_description_id: subComponent.area_description_id,
                                vender_id: subComponent.vender_id,
                                category_id: subComponent.category_id,
                                area_id: Number(subComponent.area_id),
                                component_name: subComponent.component_name,
                                vendor_name: subComponent.vendor_name,
                                unit_price: subComponent.unit_price,
                                work_done: subComponent.work_done,
                                work_done_source: subComponent.work_done_source,
                                add_receive_id: subComponent.add_receive_id,
                                date: subComponent.date,
                                status: subComponent.status,
                                product_id: subComponent.product_id
                            }))
                        }))
                    }));

                }

                console.warn("areacheckkksdasdk", updatedRows);

                setRows1(updatedRows);

                const categoryWiseTotalUnitPrice = {};
                const categoryWiseTotalCostPrice = {};
                const uniqueCategories = new Set();

                // Sum unit_price from sub_component_order
                sub_component_order.forEach((item) => {
                    const categoryId = item.category_id;
                    const unitPrice = parseFloat(item.unit_price) || 0;

                    uniqueCategories.add(categoryId);

                    if (!categoryWiseTotalUnitPrice[categoryId]) {
                        categoryWiseTotalUnitPrice[categoryId] = 0;
                    }
                    categoryWiseTotalUnitPrice[categoryId] += unitPrice;
                });

                // Sum cost_price from component_order
                component_order.forEach((item) => {
                    const categoryId = item.category_id;
                    const costPrice = parseFloat(item.cost_price) || 0;

                    uniqueCategories.add(categoryId);

                    if (!categoryWiseTotalCostPrice[categoryId]) {
                        categoryWiseTotalCostPrice[categoryId] = 0;
                    }
                    categoryWiseTotalCostPrice[categoryId] += costPrice;
                });

                // Merge unit price, cost price, and calculate the difference
                const categoryWithTotalPrice = [...uniqueCategories].map((categoryId) => {
                    const totalUnitPrice = categoryWiseTotalUnitPrice[categoryId] || 0;
                    const totalCostPrice = categoryWiseTotalCostPrice[categoryId] || 0;
                    const costMinusUnit = totalCostPrice - totalUnitPrice; // Calculate difference

                    return {
                        category_id: categoryId,
                        total_unit_price: totalUnitPrice,
                        total_cost_price: totalCostPrice,
                        cost_minus_unit: costMinusUnit
                    };
                });

                settotalUnitPrice1(categoryWithTotalPrice);
                // console.warn("mithlesh", categoryWithTotalPrice);

                if (updatedRows.length > 0) {
                    const { id, name } = updatedRows[0].product_id;
                }
            }
            if (extra_charges_store.length > 0) {
                const updatedRows = extra_charges_store.map(item => ({
                    id: item.id,
                    order_id: item.order_id,
                    customer_id: item.customer_id,
                    category_id: item.category_id,
                    name: item.name,
                    pro_qty: item.pro_qty,
                    price: item.price,
                    total_amount: item.total_amount,
                    vendor_id: item.vendor_id,
                    // vendor_id: { id: item.vendor_id, vendor_name: item.vendor_name },

                }));
                setRows1(updatedRows);
            }
            if (product_other_data.length > 0) {
                const updatedRowsother = product_other_data && product_other_data.map(item => ({
                    tr_charge: item.tr_charge,
                    lable_charge: item.lable_charge,
                    id: item.id,
                    // name: item.name || '',
                }));
                // setRowother(updatedRowsother);
            }
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };

    const ProductView = async (order) => {
        localStorage.setItem('Vendor_view_id', order);
        setModalState({ ...modalState, orderVendorView: true });
    };
    const VendorRecriveStatusChange = async (add_receive_id, newStatus) => {
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Status it!",
            });

            if (result.isConfirmed) {
                const token = localStorage.getItem('token');
                const url = `${process.env.REACT_APP_API_URL}Vendor-receive-manufacture-status/${add_receive_id}`;

                const config = {
                    method: 'post',
                    url: url,
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                    data: {
                        status: newStatus,
                    },
                };

                const response = await axios(config);

                if (response.data.status === 1) {
                    toast.success(response.data.message);
                } else {
                    toast.error(response.data.message);
                }
                fetchOrderlist();
            }
        } catch (error) {
            console.error("Error updating status:", error);
            toast.error("Error updating status. Please try again later.");
        }
    };

    const VendorDelete = async (add_receive_id) => {
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
            });
            if (result.isConfirmed) {
                let url = `${process.env.REACT_APP_API_URL}Vendor-receive-delete/${add_receive_id}`;
                const config = {
                    method: 'get',
                    url: url,
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                };
                const response = await axios(config);
                if (response.data.status === 1) {
                    toast.success(response.data.message);
                    fetchOrderlist();
                } else {
                    toast.error(response.data.message);
                }

            }
        } catch (error) {
            console.error("There was a problem with the fetch operation:", error);
        } finally {
            // setLoadinglist(false);
        }
    };


    const handleView = (order) => {
        localStorage.setItem('orderRawproduct_id', order);
        setModalState({ ...modalState, orderProductView: true });
    };
    const handleViewProduct = (id) => {
        localStorage.setItem('product_view_id', id);
        setModalState({ ...modalState, orderProductView: true });
    };

    const vendorProductColumns = useMemo(
        () => [
            {
                Header: 'Sr No',
                accessor: (row, i) => i + 1,
            },
            {
                Header: 'Or. Id',
                accessor: 'order_id',
            },
            {
                Header: 'Cu. Name',
                accessor: 'customer_name',
            },
            {
                Header: 'Cu. Type',
                accessor: 'customer_type',
            },

            {
                Header: 'Category Name',
                accessor: 'product_data',
                id: 'category_name',
                Cell: ({ cell: { value } }) => (
                    <tbody className='table_child text-center'>
                        {value.map((product, index) => (
                            <tr key={index}>
                                <td className='mb-0 pb-0'>{product.category_name}</td>
                            </tr>
                        ))}
                    </tbody>
                ),
            },



            {
                Header: 'Total Cost Price',
                accessor: 'product_data',
                id: 'total_cost_price',
                Cell: ({ cell: { value }, row }) => {
                    const formatPrice = (price) => {
                        if (price === undefined || price === null) return '';
                        return new Intl.NumberFormat().format(price);
                    };

                    return (
                        <>
                            {value && value.map((product, index) => (
                                <tr key={index}>
                                    <td>
                                        <Form.Group>
                                            <Form.Control
                                                type="text"
                                                placeholder="Total Cost Price"
                                                name="unit_price1"
                                                className='w-auto-design'
                                                value={formatPrice(product.total_cost_price)}
                                                disabled
                                            />
                                        </Form.Group>
                                    </td>
                                </tr>
                            ))}
                        </>
                    );
                },
            },
            {
                Header: 'Total Sale Price',
                accessor: 'product_data',
                id: 'total_sale_price',
                Cell: ({ cell: { value }, row }) => {
                    const formatPrice = (price) => {
                        if (price === undefined || price === null) return '';
                        return new Intl.NumberFormat().format(price);
                    };

                    return (
                        <>
                            {value && value.map((product, index) => (
                                <tr key={index}>
                                    <td>
                                        <Form.Group>
                                            <Form.Control
                                                type="text"
                                                placeholder="Total Sale Price"
                                                name="unit_price1"
                                                className='w-auto-design'
                                                value={formatPrice(product.total_sale_price)}
                                                disabled
                                            />
                                        </Form.Group>
                                    </td>
                                </tr>
                            ))}
                        </>
                    );
                },
            },

            {
                Header: 'Action',
                accessor: 'product_data',
                id: 'unit_price',

                Cell: ({ cell: { value }, row }) => {
                    // const formatPrice = (price) => {
                    //     if (price === undefined || price === null) return '';
                    //     return new Intl.NumberFormat().format(price);
                    // };
                    const formatPrice = (price) => {
                        if (price === undefined || price === null) return '';
                        return price.toString(); // Converts the price to a string without adding commas
                    };

                    return (
                        <tbody>
                            {value && value.map((product, index) => (
                                <tr key={index}>
                                    {/* <td>
                                        <Form.Group>
                                            <Form.Control
                                                type="text"
                                                placeholder="Price"
                                                name="unit_price"
                                                className='w-auto-design'
                                                value={formatPrice(
                                                    productDetails[row.order_id]?.[product.vender_id]?.[product.product_id]?.[product.qty]?.unit_price
                                                    ?? product.unit_price
                                                )}
                                                disabled

                                            />

                                        </Form.Group>
                                    </td> */}
                                    <td></td>
                                    <td>
                                        <button
                                            className="btn btn-primary"
                                            // onClick={() => handleButtonClick(product)}
                                            onClick={(e) => handleInputChange1(
                                                product.order_id,
                                                product.category_id,
                                                product.total_cost_price,
                                                product.total_sale_price,
                                                product.category_name,
                                                product.remaining_cost,
                                            )}
                                        >
                                            <FaEdit />
                                        </button>
                                    </td>
                                    {/* <td>
                                    <Link
                                        to="#"
                                        style={{
                                            "--i": "red",
                                            color: product.date !== null ? "red" : "gray"
                                        }}
                                        className="p-2"
                                        onClick={product.date !== null ? () => VendorDelete(product.vdr_id) : (e) => e.preventDefault()}
                                    >
                                        <MdDelete />
                                    </Link>
                                    </td> */}
                                </tr>
                            ))}
                        </tbody>
                    );
                },
            },

        ],
        []
    );

    // console.warn("fgfg", Rows)
    const buttonname = "Receive Material";
    const buttonclass = "btn-added btn_custum_new";
    const title = "Product Details";
    const titlesec = "Actual Receive History";

    const handleStatusChange = (e) => {
        setSelectedStatus(e.target.value); // No need to parseInt, keep it as a string
    };

    // want to show data in decending order by order_id

    const filteredOrderList = selectedStatus ? orderlist.filter(item => item.customer_name === selectedStatus) : orderlist;

    const uniqueRows = Array.from(new Set(Rows.map(row => row.vender_id)))
        .map(vender_id => Rows.find(row => row.vender_id === vender_id));

    const uniqueComponents = Array.from(new Set(Rows.map(row => row.component_id)))
        .map(component_id => Rows.find(row => row.component_id === component_id));
    return (
        <>
            <ToastContainer />

            <div className='justify-content-center processing'>
                <div className='text-center'>
                    <Row>
                        <Col md={12} xs={12} lg={12} className='duedrop1'>
                            <Form.Select
                                aria-label="Default select example"
                                onChange={handleStatusChange}
                                value={selectedStatus}
                                style={{ border: '1px solid #8080802' }}
                            >
                                <option value=''>Customer Name</option>
                                {orderlist.map((order) => (
                                    <option key={order.customer_name} value={order.customer_name}>
                                        {order.customer_name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>
                    </Row>
                </div>
            </div>
            <Vendorproductt columns={vendorProductColumns} data={filteredOrderList} title={title} addvendor={buttonname} btnclass={buttonclass} />

            <hr />
            <Modal
                size="lg"
                show={modalState.addReceive}
                onHide={() => setModalState({ ...modalState, addReceive: false })}
                aria-labelledby="example-modal-sizes-title-lg"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Body>
                    <AddReceive onSave={() => { setModalState({ ...modalState, addReceive: false }); }} />
                </Modal.Body>
            </Modal>

            <Modal
                size="lg"
                show={modalState.orderProductView}
                onHide={() => setModalState({ ...modalState, orderProductView: false })}
                aria-labelledby="example-modal-sizes-title-lg"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <h5 style={{ color: "gray" }} className="card-title">Customer Product View Details</h5>
                </Modal.Header>

                <Modal.Body closeButton>
                    <CustumerProductview onSave={() => { setModalState({ ...modalState, orderProductView: false }); }} />
                </Modal.Body>
            </Modal>
            <Modal
                size="lg"
                show={modalState.orderVendorView}
                onHide={() => setModalState({ ...modalState, orderVendorView: false })}
                aria-labelledby="example-modal-sizes-title-lg"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <h5 style={{ color: "gray" }} className="card-title">Customer Vendor View Details</h5>
                </Modal.Header>
                <Modal.Body closeButton>
                    <VendorReceiveView onSave={() => { setModalState({ ...modalState, orderVendorView: false }); }} />
                </Modal.Body>
            </Modal>

            <>
                <Modal show={show} onHide={handleClose} size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>Vendor Payment View Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <h5 className='text-capitalize' style={{ color: "#e22a6f" }}>Category : {modalData.category_name}</h5>
                        </div>

                        <Row>
                            {(() => {
                                const uniqueVendorIds = new Set();

                                return rows1.map((row1, rowIndex) => (
                                    <Row key={rowIndex} className="mt-3">
                                        {row1?.component_order?.map((field, fieldIndex) =>
                                            field.category_id == modalData.category_id &&
                                            field.sub_component_order?.map((extraField, extraFieldIndex) => {
                                                if (uniqueVendorIds.has(extraField.vender_id)) return null; // Skip duplicate vendors

                                                uniqueVendorIds.add(extraField.vender_id); // Mark as displayed

                                                return (
                                                    <>
                                                        <React.Fragment key={extraFieldIndex}>
                                                            {/* Component Name */}
                                                            <Col xs={12} md={2}>
                                                                <Form.Group className="mb-2">
                                                                    <Form.Label>Component</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        value={componentOptions.find(option => option.value == extraField.component_id)?.label || 'N/A'}
                                                                        disabled
                                                                    />
                                                                </Form.Group>
                                                            </Col>

                                                            {/* Vendor Name */}
                                                            <Col xs={12} md={2}>
                                                                <Form.Group className="mb-2">
                                                                    <Form.Label>Vendor Name</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        value={vendorOptions.find(option => option.value == extraField.vender_id)?.label || 'N/A'}
                                                                        disabled
                                                                    />
                                                                </Form.Group>
                                                            </Col>

                                                            {/* Price */}
                                                            <Col xs={12} md={2}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Price</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        value={extraField.unit_price}
                                                                        onChange={(e) => handleUnitprice(rowIndex, fieldIndex, extraFieldIndex, e.target.value, field.category_id)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xs={12} md={2}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>W done</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        value={extraField.work_done || ''}
                                                                        onChange={(e) =>
                                                                            handleWorkDoneprice(
                                                                                rowIndex,
                                                                                fieldIndex,
                                                                                extraFieldIndex,
                                                                                e.target.value,
                                                                                field.category_id
                                                                            )
                                                                        }
                                                                        disabled={extraField.work_done_source === "ms"}
                                                                    />
                                                                </Form.Group>
                                                            </Col>


                                                            {/* Date */}
                                                            <Col xs={12} md={2}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Date</Form.Label>
                                                                    <Form.Control
                                                                        type="date"
                                                                        value={extraField.date}
                                                                        onChange={(e) => handleDate(rowIndex, fieldIndex, extraFieldIndex, e.target.value)}
                                                                        onFocus={(e) => e.target.showPicker()}
                                                                    />
                                                                </Form.Group>
                                                            </Col>

                                                            {/* Receive Status */}
                                                            <Col xs={12} md={1}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Receive</Form.Label>

                                                                    <select
                                                                        className='form-select w-auto noborder'
                                                                        style={{ color: extraField.status === 1 ? 'green' : 'red' }}
                                                                        defaultValue={extraField.status === 1 ? 'Yes' : 'No'}
                                                                        onChange={(e) => {
                                                                            const newStatus = e.target.value === 'Yes' ? 1 : 0;
                                                                            VendorRecriveStatusChange(extraField.add_receive_id, newStatus, e.target.value);
                                                                        }}
                                                                    >
                                                                        <option value="Yes" className='text-success' selected={extraField.status === 1}>Yes</option>
                                                                        <option value="No" className='text-danger' selected={extraField.status === 0}>No</option>
                                                                    </select>
                                                                </Form.Group>
                                                            </Col>

                                                            {/* Delete Button */}
                                                            {/* <Col xs={12} md={1}>
                                                                <Button
                                                                    className="mt-4"
                                                                    style={{
                                                                        "--i": "red",
                                                                        color: extraField.date !== null ? "red" : "gray"
                                                                    }}
                                                                    onClick={extraField.date !== null ? () => VendorDelete(extraField.add_receive_id,) : (e) => e.preventDefault()}
                                                                >
                                                                    <MdDelete/>
                                                                </Button>
                                                            </Col> */}

                                                            {/* Save/Update Button */}
                                                            <Col xs={12} md={1}>
                                                                <Button
                                                                    className="mt-4"
                                                                    variant="primary"
                                                                    onClick={() => extraField.add_receive_id == null
                                                                        ? handleSubmit1(extraField.id, extraField.component_id, extraField.vender_id, extraField.area_description_id, extraField.unit_price, extraField.work_done, extraField.date, extraField.product_id, modalData.order_id)
                                                                        : handleUpdate1(extraField.id, extraField.component_id, extraField.vender_id, extraField.area_description_id, extraField.unit_price, extraField.work_done, extraField.add_receive_id, extraField.date, extraField.product_id, modalData.order_id)
                                                                    }
                                                                >
                                                                    {extraField.add_receive_id == null ? "Save" : "Update"}
                                                                </Button>

                                                            </Col>
                                                        </React.Fragment>
                                                    </>
                                                );
                                            })
                                        )}
                                    </Row>
                                ));
                            })()}

                            <Col xs={12} md={4}>
                                <Form.Label>Total Balance of Category Cost Price</Form.Label>

                                {totalUnitPrice1 && totalUnitPrice1.map((item) => (
                                    modalData.category_id == item.category_id && (
                                        <Form.Control
                                            type="text"
                                            className="disabled_input"
                                            value={item.cost_minus_unit}
                                            disabled
                                        />
                                    )
                                ))}


                            </Col>

                            <Col xs={12} md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Total Balance of Category Sale Price</Form.Label>
                                    <Form.Control
                                        type="text"
                                        className="disabled_input"
                                        value={modalData.total_sale_price}
                                        disabled
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>

        </>
    );
};

export default VendorManufactureProductdetails;
